import { navigateToUrl } from 'single-spa'

(function () {
  var ua = window.navigator.userAgent.toLowerCase()
  var wxwork = ua.indexOf('wxwork/') !== -1//企业微信
  let jump = {
    orderTypes: {
      '10': 'flight',
      '11': 'hotel',
      '12': 'train',
      '13': 'insurance',
      '14': 'general',
      '16': 'car',
      '17': 'intl_flight'
    },
    env: {
      // 在iframe中,因dd无法响应ready事件执行cookie自动登录逻辑
      dd: ua.indexOf('dingtalk') !== -1 && self == top,
      weixin: ua.match(/MicroMessenger/i) == 'micromessenger' && !wxwork,
      feishu: ua.indexOf('lark/') !== -1,//飞书
      wxwork: wxwork
    }
  }

  jump.to = function (path, query, open) {
    if (query) {
      if (path.indexOf('?') == -1) {
        path += '?'
      }
      path += queryToStr(query)
    }
    let url = $ZConfig.getOrigin() + path
    if (open) {
      window.open(url)
    } else {
      window.top.location.href = url
    }
  }

  jump.toLogin = function () {
    window.top.location.href = $ZConfig.getPassportUrl() + '/login'
  }

  jump.forbid = () => {
    location.replace('/v/powerTip.html')
  }
  // to订单明细
  jump.orderDetail = function (vue, orderId) {
    if (!orderId) {
      jump.errorToHome(vue, '未知的订单')
      return
    }
    let bizType = this.orderTypes[typeof orderId === 'number' ? String(orderId).substr(0, 2) : orderId.substr(0, 2)]
    if (bizType) {
      let url = null
      switch (bizType) {
      case 'flight':
        case 'intl_flight':
          url = `/v/flight/orderDetail?orderId=${orderId}`
          break
        case 'car':
          url = `/v/votapub/common/carOrderListDetail?orderId=${orderId}`
          break
        case 'hotel':
          url = `/v/hotel/orderDetail?orderId=${orderId}`
          break
        case 'insurance':
          url = `/insurance/showInsuranceOrder/${orderId}.html`
          break
        case 'train':
          url = `/v/train/orderDetail?orderId=${orderId}`
          break
        case 'general':
          url = `/v/votapub/common/generalOrderDetail?orderId=${orderId}`
          break
      }
      $jump.to(url, null, true)
    } else {
      vue.$Message.waring('暂未开发该订单明细页')
    }
  }

  function queryToStr(query) {
    var arr = []
    for (var k in query) {
      var v = query[k]
      if (v) {
        arr.push(k + '=' + v)
      }
    }
    return arr.join('&')
  }

  // 跳转至支付控制台 app(vue, orderId, query, allowBack)
  jump.toPay = function (vue, orderIds, backPath) {
    let queryLink = null
    if (backPath) {
      const keyOfQuery = Object.keys(backPath)
      const queryMap = keyOfQuery.map(item => `${item}=${backPath[item]}`)
      queryLink = queryMap.join('&')
    }
    if (queryLink) {
      this.to(`/v/pay-channel.html?orderIds=${orderIds}&${queryLink}`)
    }else {
      this.to(`/v/pay-channel.html?orderIds=${orderIds}`)
    }
  }
  // 跨项目路由跳转,临时解决方案; 部分浏览器,跨项目路由跳转publicpath有问题
  jump.goLocPage = function (pageUrl, router = null, isReplace = false) {
    if (isReplace) {
      history.replaceState(null, null, pageUrl)
    } else {
      navigateToUrl(pageUrl)
    }
  }
  
  window.$jump = jump
})()
